import { create } from 'zustand';

interface AuthState {
  token: string | null;
  login: string | null;
  setAuth: (token: string, login: string) => void;
  clear: () => void;
}

const STORAGE_KEY = 'edo-auth';

function loadFromStorage(): { token: string | null; login: string | null } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { token: null, login: null };
    return JSON.parse(raw);
  } catch {
    return { token: null, login: null };
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  ...loadFromStorage(),
  setAuth: (token, login) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, login }));
    set({ token, login });
  },
  clear: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ token: null, login: null });
  },
}));
